import { SetFeedback } from "./SetFeedback";

export type ESet = {
  reps: number;
  weightLbs: number | BodyWeight;
  done: boolean;
  feedback?: SetFeedback;
}

export const BODY_WEIGHT = null
export type BodyWeight = typeof BODY_WEIGHT
export type WeightLbs = number | BodyWeight

export const isBodyWeight = (weightLbs: WeightLbs): weightLbs is BodyWeight => weightLbs === BODY_WEIGHT

export const sumWeightLbs = (weights: WeightLbs[]): number =>
  weights.reduce<number>((sum, w) => sum + (isBodyWeight(w) ? 0 : w), 0)

export const formatWeightLbs = (weightLbs: WeightLbs): string =>
  isBodyWeight(weightLbs) ? 'BW' : `${weightLbs} lbs`

export type SetTemplate = {
  reps: number;
  weightLbs: number | BodyWeight;
}
